import { Box, HStack, Image, StackProps, Text, VStack } from "@chakra-ui/react";
import { resizeServingUrl } from "@/utils/image";
import { ISeriesListItem } from "@/models/seriesListItem";
import { FollowOnlyIcon } from "./followOnlyIcon";
import { FollowMutualOnlyIcon } from "./followMutualOnlyIcon";
import { useLocalState } from "./useLocalState";

type Props = {
  item: ISeriesListItem;
} & StackProps;

export const SeriesListItem = ({ item, ...props }: Props) => {
  const { showTopRightBadge, topRightBadgeText } = useLocalState(item);
  return (
    <HStack
      w="full"
      gap="3"
      alignItems="flex-start"
      bg="backgroundPrimary"
      px="4"
      py="2"
      {...props}
    >
      <Box
        w="116px"
        h="78px"
        borderRadius={8}
        overflow="hidden"
        flexShrink={0}
        position="relative"
      >
        {item.thumbnailUrl ? (
          <Image
            src={resizeServingUrl(item.thumbnailUrl, 120 * 2)!}
            alt={item.title}
            w="full"
            h="full"
            objectFit="cover"
          />
        ) : (
          <Box w="full" h="full" bg="gray.300" />
        )}

        <Box position="absolute" bottom="0" left="0">
          {item.sharedWithStatus === "follower" ? (
            <FollowOnlyIcon />
          ) : item.sharedWithStatus === "mutual-follower" ? (
            <FollowMutualOnlyIcon />
          ) : null}
        </Box>

        {showTopRightBadge && (
          <Box
            bg="rgba(102, 102, 102, 0.6)"
            borderRadius="full"
            px="6px"
            h="16px"
            justifyContent="center"
            alignItems="center"
            position="absolute"
            top="4px"
            right="4px"
          >
            <Text color="white" fontSize="8px" fontWeight="bold">
              {topRightBadgeText}
            </Text>
          </Box>
        )}
      </Box>

      <VStack
        w="full"
        alignItems="flex-start"
        justifyContent="space-between"
        minH="78px"
      >
        <VStack w="full" gap="2" alignItems="flex-start">
          <Text
            fontSize={12}
            fontWeight="bold"
            color="contentTertiary"
            lineHeight={1.25}
          >
            {item.scriptType === "CHAT" ? "チャットノベル" : "ノベル"}
          </Text>

          <Text
            fontSize={16}
            fontWeight="bold"
            color="contentPrimary"
            lineHeight={1.25}
          >
            {item.title}
          </Text>
        </VStack>

        <Text
          fontSize={12}
          fontWeight="bold"
          color={item.isPublic ? "contentPositive" : "contentNegative"}
        >
          {item.isPublic ? "公開中" : "下書き"}
        </Text>
      </VStack>
    </HStack>
  );
};
